import React, { Component } from 'react';
import { API_ENDPOINT } from '../../constants';
import ErrorModal from '../../components/errorModal';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import DeleteModal from '../../components/deleteModal';

function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class ConnectedGroupsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props.initialData,
        };

    }


    componentDidMount() {

    }
    componentDidUpdate(prevProps) {
        if (this.state.previewItem && JSON.stringify(this.props.items) !== JSON.stringify(prevProps.items)) {
            const item = this.props.items.find(el => el._id === this.state.previewItem._id);
            if (item) {
                this.setState({ previewItem: item });
            }
        }
    }
    generateTokens = () => {
        if (this.state.previewItem) {
            const groupId = this.state.previewItem?._id;
            if (groupId) {
                this.setState({ loadingGenerateTokens: true }, () => {
                    fetch(API_ENDPOINT + `/data/webDocSettings/generate-tokens/${groupId}`, {
                        method: 'GET',
                        headers: {
                            'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                            'content-type': 'application/json'
                        }
                    }).then(parseJSON).then(({ result, status }) => {
                        this.setState({ generateTokenModal: false, loadingGenerateTokens: false });
                        if (this.props.onUpdate) this.props.onUpdate();
                    })

                });
            } else {
                this.setState({ generateTokenModal: false });
            }

        }
    }
    render() {
        const items = this.props.items ?? [];
        const previewItem = this.state.previewItem ?? null;
        return (
            <div className='connected-groups-to-webdoc-component-wrap'>
                {
                    this.state.loadingGenerateTokens ?
                        <div className="whole-screen-loader-wrap">
                            <div className="loader-wrap">
                                <Player
                                    autoplay={true}
                                    loop={true}
                                    renderer={'svg'}
                                    src="/lf30_editor_l5cxzdyf.json"
                                    style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                                ></Player>

                            </div>
                        </div>
                        :
                        null
                }
                <div className='connected-groups-to-webdoc-title'>{'Connected groups to WebDoc'.translate(this.props.lang)}</div>
                {
                    items.map((item, index) => {
                        const active = item?.webdoc?.active ? 'active' : 'inactive';
                        const name = `${item?.name} (${item?.alias})`;
                        return (
                            <div className='connected-group-to-webdoc-wrap'>
                                <div className='connected-group-to-webdoc-item' onClick={() => {
                                    this.setState({ previewItem: { ...item } });
                                }}>
                                    <div className={`connected-group-to-webdoc-status-${active}`}></div>
                                    <div className='connected-group-to-webdoc-name'>{name}</div>
                                </div>
                            </div>
                        )
                    })
                }
                {
                    previewItem ?
                        <Modal
                            isOpen={previewItem}
                            toggle={() => this.setState({ previewItem: null })}
                            className='connected-group-to-webdoc-preview-modal'
                            centered
                            size="lg"
                        >
                            <ModalHeader toggle={() => this.setState({ previewItem: null })}>
                                {'Preview'.translate(this.props.lang)}
                            </ModalHeader>
                            <ModalBody>
                                <div className='connected-group-to-webdoc-preview-wrap'>
                                    <div className='item-field'>
                                        {'Clinic group name'.translate(this.props.lang)}:
                                        <span>{previewItem?.name}</span>
                                    </div>
                                    <div className='item-field'>
                                        {'Clinic group alias'.translate(this.props.lang)}:
                                        <span>{previewItem?.alias}</span>
                                    </div>
                                    <div className='item-field flex-center'>
                                        {'Connection to WebDoc'.translate(this.props.lang)}:
                                        <div className='active-status-value'>
                                            <div className={`connected-group-to-webdoc-status-${previewItem?.webdoc?.active ? 'active' : 'inactive'}`}></div>
                                            {previewItem?.webdoc?.active ? 'Active'.translate(this.props.lang) : 'Inactive'.translate(this.props.lang)}
                                        </div>
                                    </div>
                                    <div className='item-field'>
                                        {'WebDoc api'.translate(this.props.lang)}:
                                        <span>{previewItem?.webdoc?.api}</span>
                                    </div>
                                    <div className='item-field'>
                                        {'WebDoc client id'.translate(this.props.lang)}:
                                        <span>{previewItem?.webdoc?.clientId}</span>
                                    </div>
                                    <div className='item-field'>
                                        {'WebDoc client secret'.translate(this.props.lang)}:
                                        <span>{previewItem?.webdoc?.clientSecret}</span>
                                    </div>
                                </div>
                                <div className='connected-group-to-webdoc-clinics-wrap'>
                                    <div className='connected-group-to-webdoc-clinics-title'>
                                        {'Connected departments'.translate(this.props.lang)}
                                    </div>
                                    {
                                        previewItem?.webdoc?.clinics?.map((clinic, index) => {
                                            if (clinic?.webDocId && clinic?.webDocId !== 'None')
                                                return (
                                                    <div className='connected-group-to-webdoc-clinic-item-wrap'>
                                                        <div className='connected-group-to-webdoc-clinic-item' onClick={() => {
                                                            if (this.state.showClinicPreview === index) {
                                                                this.setState({ showClinicPreview: null });
                                                            } else {
                                                                this.setState({ showClinicPreview: index });
                                                            }

                                                        }}>
                                                            {clinic?.clinicName}
                                                        </div>
                                                        {
                                                            this.state.showClinicPreview === index ?
                                                                <div className='connected-group-to-webdoc-clinic-preview-wrap'>
                                                                    <div className='item-field'>
                                                                        {'WebDoc id'.translate(this.props.lang)}:
                                                                        <span>{clinic?.webDocId}</span>
                                                                    </div>
                                                                    <div className='item-field'>
                                                                        {'Sync type'.translate(this.props.lang)}:
                                                                        <span>{clinic?.syncTypeText}</span>
                                                                    </div>
                                                                    <div className='item-field'>
                                                                        {'Tokens'.translate(this.props.lang)}:
                                                                        {
                                                                            previewItem?.webDocTokens?.find(el => el.key === clinic?.webDocId) ?
                                                                                <div className='connected-group-to-webdoc-clinic-tokens-wrap'>
                                                                                    {
                                                                                        previewItem?.webDocTokens?.find(el => el.key === clinic?.webDocId) && Object.keys(previewItem?.webDocTokens?.find(el => el.key === clinic?.webDocId)).map((key) => {
                                                                                            const token = previewItem?.webDocTokens?.find(el => el.key === clinic?.webDocId)?.[key];
                                                                                            if (typeof token === 'object') {
                                                                                                return (
                                                                                                    <div className='connected-group-to-webdoc-clinic-token-item'>
                                                                                                        <div className='scope-wrap'>{token?.scope}</div>
                                                                                                        <div className='access-token-wrap'>{'Token'.translate(this.props.lang)}: {token?.access_token ?? 'N/A'}</div>
                                                                                                        <div className='expires-in-wrap'>{'Expires in'.translate(this.props.lang)}: {token?.access_token && token?.expires_in ? token?.expires_in : 'N/A'}</div>
                                                                                                    </div>
                                                                                                )
                                                                                            }

                                                                                        })
                                                                                    }
                                                                                </div>
                                                                                :
                                                                                <span>{'No found tokens!'}</span>
                                                                        }

                                                                    </div>


                                                                </div>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                )
                                        })
                                    }
                                </div>
                            </ModalBody>
                            <ModalFooter className='modal-footer-buttons-wrap' style={{ justifyContent: 'flex-end' }}>
                                <Button color='primary' disabled={this.state.loadingGenerateTokens || !this.state.previewItem?.webdoc?.active} onClick={() => {
                                    this.setState({ generateTokenModal: true });
                                }}>
                                    {'Generate tokens'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary' onClick={() => {
                                    this.setState({ previewItem: null });
                                }}>
                                    {'Close'.translate(this.props.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.generateTokenModal ?
                        <DeleteModal
                            zIndex={9999}
                            lang={this.props.lang}
                            isOpen={this.state.generateTokenModal}
                            toggle={() => this.setState({ generateTokenModal: null })}
                            handler={() => {
                                this.generateTokens();

                            }}
                        >
                            {"Do you want to generate new tokens?".translate(this.props.lang)}

                        </DeleteModal>
                        :
                        null
                }
            </div>
        );
    }
}



export default ConnectedGroupsComponent;
